import React, { createContext, useContext } from "react";

import {
  FeedbackThreadItem,
  Leader,
  LearnerInfo,
  SectionInfo,
  ThreadItem,
} from "./types";

export interface MessageTeacherDrawerContextValue {
  section: SectionInfo;
  learner: LearnerInfo;
  leader: Leader | null;
  teacherName: string;
  threads: ThreadItem[];
  feedbackThreads: FeedbackThreadItem[];
  threadsLoading: boolean;
  feedbackThreadsLoading: boolean;
  searchInput: string;
  debouncedSearch: string;
  setSearchInput: (value: string) => void;
}

interface MessageTeacherDrawerProviderProps {
  value: MessageTeacherDrawerContextValue;
  children: React.ReactNode;
}

const MessageTeacherDrawerContext =
  createContext<MessageTeacherDrawerContextValue | null>(null);

export function MessageTeacherDrawerProvider({
  value,
  children,
}: MessageTeacherDrawerProviderProps) {
  return (
    <MessageTeacherDrawerContext.Provider value={value}>
      {children}
    </MessageTeacherDrawerContext.Provider>
  );
}

export function useMessageTeacherDrawerContext(): MessageTeacherDrawerContextValue {
  const context = useContext(MessageTeacherDrawerContext);
  if (!context) {
    throw new Error(
      "useMessageTeacherDrawerContext must be used within MessageTeacherDrawerProvider",
    );
  }
  return context;
}
